(function () {
  const CONFIG = {
    minLogoSize: 20,
    maxLogoSize: 170,
    debug: false,
  };

  const runtime = {
    cache: new Map(),
    observer: null,
    unsubscribe: null,
    initialized: false,
    running: false,
  };

  if (
    window.__CPBLogoTintFix &&
    typeof window.__CPBLogoTintFix.destroy === "function"
  ) {
    window.__CPBLogoTintFix.destroy();
  }

  function log(...args) {
    if (CONFIG.debug) {
      console.log("[CPB Logo Tint Fix]", ...args);
    }
  }

  function getStages() {
    return window.Konva?.stages?.filter((stage) => stage?.find) || [];
  }

  function getProduct() {
    return window.CPB?.getStore?.()?.getState?.()?.Product || null;
  }

  function getCategories() {
    return (
      getProduct()?.panels?.flatMap((panel) => panel.categories || []) || []
    );
  }

  function findCategoryByTitle(title) {
    return getCategories().find((category) => {
      return (
        String(category.title || "")
          .trim()
          .toLowerCase() === String(title).trim().toLowerCase()
      );
    });
  }

  function getActiveEls() {
    return Array.from(
      document.querySelectorAll(
        ".cpb-option.cpb-active, .cpb-option.cpb-selected, .cpb-active, .cpb-selected, .selected, .active"
      )
    );
  }

  function getSelectedDesignFrontUrl() {
    const designCategory = findCategoryByTitle("Design");

    if (!designCategory) return null;

    const activeEls = getActiveEls();

    for (const option of designCategory.options || []) {
      const label = option.option?.data?.label;
      const front = option.preview?.data?.front;
      const thumb = option.option?.data?.value;

      if (!front) continue;

      const isActive = activeEls.some((el) => {
        const text = String(el.textContent || "").toLowerCase();
        const html = String(el.innerHTML || "").toLowerCase();

        return (
          text.includes(String(label || "").toLowerCase()) ||
          html.includes(String(front || "").toLowerCase()) ||
          html.includes(String(thumb || "").toLowerCase())
        );
      });

      if (isActive) {
        return thumb || front;
      }
    }

    return null;
  }

  function normalizeColorValue(value) {
    const color = String(value || "").trim();

    if (!color) return null;

    if (color.startsWith("#")) {
      return color;
    }

    if (/^rgb|^hsl|^[a-z]+$/i.test(color)) {
      return color;
    }

    return null;
  }

  function getVisibleTextColor() {
    for (const stage of getStages()) {
      const textNodes = stage.find("Text") || [];

      for (const node of textNodes) {
        if (!node.isVisible?.()) continue;

        const fill = normalizeColorValue(node.fill?.());
        if (!fill) continue;

        const lowerFill = fill.toLowerCase();

        if (
          lowerFill !== "black" &&
          lowerFill !== "#000" &&
          lowerFill !== "#000000" &&
          lowerFill !== "rgb(0,0,0)" &&
          lowerFill !== "rgba(0,0,0,1)"
        ) {
          return fill;
        }
      }
    }

    return null;
  }

  function getSelectedThreadColorFromDom() {
    const threadCategory = getCategories().find((category) => {
      return (
        String(category.title || "")
          .trim()
          .toLowerCase() === "thread color"
      );
    });

    if (!threadCategory) return null;

    const activeEls = Array.from(
      document.querySelectorAll(
        ".cpb-option.cpb-active, .cpb-option.cpb-selected, .cpb-active, .cpb-selected"
      )
    );

    for (const option of threadCategory.options || []) {
      const label = option.option?.data?.label;
      const value = normalizeColorValue(option.option?.data?.value);

      if (!label || !value) continue;

      const isActive = activeEls.some((el) => {
        return String(el.textContent || "")
          .trim()
          .toLowerCase()
          .includes(String(label).trim().toLowerCase());
      });

      if (isActive) {
        return value;
      }
    }

    return null;
  }

  function hexToRgb(color) {
    const hex = String(color || "")
      .replace("#", "")
      .trim();

    if (hex.length === 3) {
      return {
        r: parseInt(hex[0] + hex[0], 16),
        g: parseInt(hex[1] + hex[1], 16),
        b: parseInt(hex[2] + hex[2], 16),
      };
    }

    if (hex.length === 6) {
      return {
        r: parseInt(hex.slice(0, 2), 16),
        g: parseInt(hex.slice(2, 4), 16),
        b: parseInt(hex.slice(4, 6), 16),
      };
    }
    return null;
  }

  function getTargetColor() {
    return getVisibleTextColor() || getSelectedThreadColorFromDom();
  }

  function getImageSrc(image) {
    return image?.currentSrc || image?.src || "";
  }

  function isCanvas(image) {
    return image instanceof HTMLCanvasElement;
  }

  function isImageElement(image) {
    return image instanceof HTMLImageElement;
  }

  function getCanvasImageStats(image) {
    try {
      const width = image.naturalWidth || image.width;
      const height = image.naturalHeight || image.height;

      if (!width || !height) return null;

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0, width, height);

      const data = ctx.getImageData(0, 0, width, height).data;

      let visible = 0;
      let white = 0;

      for (let i = 0; i < data.length; i += 4) {
        const alpha = data[i + 3];

        if (alpha <= 20) continue;

        visible += 1;

        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];

        if (r > 220 && g > 220 && b > 220) {
          white += 1;
        }
      }

      return {
        visible,
        white,
        whiteRatio: visible ? white / visible : 0,
      };
    } catch (error) {
      return null;
    }
  }

  function hideWhiteLogoBackgroundNodes(targetNode) {
    const stage = targetNode.getStage?.();

    if (!stage) return;

    const targetWidth = Number(targetNode.width?.() || 0);
    const targetHeight = Number(targetNode.height?.() || 0);
    const targetX = Number(targetNode.x?.() || 0);
    const targetY = Number(targetNode.y?.() || 0);

    const imageNodes = stage.find("Image") || [];

    imageNodes.forEach((node) => {
      if (node === targetNode) return;
      if (!isLogoCandidate(node)) return;
      if (!node.isVisible?.()) return;

      const width = Number(node.width?.() || 0);
      const height = Number(node.height?.() || 0);
      const x = Number(node.x?.() || 0);
      const y = Number(node.y?.() || 0);

      const isSameArea =
        Math.abs(width - targetWidth) <= 8 &&
        Math.abs(height - targetHeight) <= 8 &&
        Math.abs(x - targetX) <= 12 &&
        Math.abs(y - targetY) <= 12;

      if (!isSameArea) return;

      const image = node.image?.();
      if (!image) return;

      const stats = getCanvasImageStats(image);

      if (stats && stats.whiteRatio > 0.55) {
        node.visible(false);
        node.opacity(0);
        node.getLayer?.()?.batchDraw?.();
      }
    });
  }

  function isLogoCandidate(node) {
    if (!node?.isVisible?.()) return false;

    const width = Number(node.width?.() || 0);
    const height = Number(node.height?.() || 0);

    if (width < CONFIG.minLogoSize || height < CONFIG.minLogoSize) return false;
    if (width > CONFIG.maxLogoSize || height > CONFIG.maxLogoSize) return false;

    const stage = node.getStage?.();
    const stageWidth = Number(stage?.width?.() || 0);
    const stageHeight = Number(stage?.height?.() || 0);

    if (stageWidth && width > stageWidth * 0.45) return false;
    if (stageHeight && height > stageHeight * 0.45) return false;

    return true;
  }

  function hideLogoAreaWhitePath(targetNode) {
    const stage = targetNode.getStage?.();

    if (!stage) return;

    const targetRect = targetNode.getClientRect?.({ relativeTo: stage }) || {};
    const paths = stage.find("Path") || [];

    paths.forEach((path) => {
      if (!path.isVisible?.()) return;

      const fill = String(path.fill?.() || "")
        .trim()
        .toLowerCase();

      if (
        fill !== "#fff" &&
        fill !== "#ffffff" &&
        fill !== "white" &&
        fill !== "rgb(255,255,255)" &&
        fill !== "rgba(255,255,255,1)"
      ) {
        return;
      }

      const pathRect = path.getClientRect?.({ relativeTo: stage }) || {};

      const isSameArea =
        Math.abs((pathRect.width || 0) - (targetRect.width || 0)) <= 12 &&
        Math.abs((pathRect.height || 0) - (targetRect.height || 0)) <= 12 &&
        Math.abs((pathRect.x || 0) - (targetRect.x || 0)) <= 12 &&
        Math.abs((pathRect.y || 0) - (targetRect.y || 0)) <= 12;

      if (!isSameArea) return;

      if (typeof path.fillEnabled === "function") {
        path.fillEnabled(false);
      }

      if (typeof path.fill === "function") {
        path.fill("rgba(0,0,0,0)");
      }

      if (typeof path.opacity === "function") {
        path.opacity(0);
      }

      path.getLayer?.()?.batchDraw?.();
    });
  }

  function loadImage(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();

      if (!src.startsWith("data:")) {
        img.crossOrigin = "anonymous";
      }

      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  }

  async function createTintedCanvas(src, color) {
    const cacheKey = `v10|${src.slice(0, 160)}|${src.length}|${color}`;

    if (runtime.cache.has(cacheKey)) {
      return runtime.cache.get(cacheKey);
    }

    const img = await loadImage(src);

    const width = img.naturalWidth || img.width;
    const height = img.naturalHeight || img.height;

    if (!width || !height) return null;

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext("2d");

    ctx.clearRect(0, 0, width, height);
    ctx.drawImage(img, 0, 0, width, height);

    const rgb = hexToRgb(color);

    if (rgb) {
      const imageData = ctx.getImageData(0, 0, width, height);
      const data = imageData.data;

      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const alpha = data[i + 3];

        const isTransparent = alpha <= 20;

        const isLightBackground = r > 200 && g > 200 && b > 200;

        if (isTransparent || isLightBackground) {
          data[i] = 0;
          data[i + 1] = 0;
          data[i + 2] = 0;
          data[i + 3] = 0;
          continue;
        }

        data[i] = rgb.r;
        data[i + 1] = rgb.g;
        data[i + 2] = rgb.b;
        data[i + 3] = 255;
      }

      ctx.putImageData(imageData, 0, 0);
    } else {
      ctx.globalCompositeOperation = "source-in";
      ctx.fillStyle = color;
      ctx.fillRect(0, 0, width, height);
      ctx.globalCompositeOperation = "source-over";
    }

    runtime.cache.set(cacheKey, canvas);

    return canvas;
  }

  async function tintLogoNodes() {
    if (runtime.running) return;

    runtime.running = true;

    try {
      const color = getTargetColor();

      if (!color) return;

      let changed = 0;

      for (const stage of getStages()) {
        const imageNodes = stage.find("Image") || [];

        for (const node of imageNodes) {
          if (!isLogoCandidate(node)) continue;

          const currentImage = node.image?.();
          const selectedDesignFrontUrl = getSelectedDesignFrontUrl();

          if (
            selectedDesignFrontUrl &&
            node._cpbLogoTintOriginalSrc !== selectedDesignFrontUrl
          ) {
            node._cpbLogoTintOriginalSrc = selectedDesignFrontUrl;
            node._cpbLogoTintLastColor = null;
          } else if (!selectedDesignFrontUrl && isImageElement(currentImage)) {
            const src = getImageSrc(currentImage);

            if (src && node._cpbLogoTintOriginalSrc !== src) {
              node._cpbLogoTintOriginalSrc = src;
              node._cpbLogoTintLastColor = null;
            }
          }

          const originalSrc = node._cpbLogoTintOriginalSrc;

          if (!originalSrc) continue;

          if (isCanvas(currentImage) && node._cpbLogoTintLastColor === color) {
            continue;
          }

          const tintedCanvas = await createTintedCanvas(originalSrc, color);

          if (!tintedCanvas) continue;

          node.image(tintedCanvas);
          node._cpbLogoTintLastColor = color;

          if (typeof node.opacity === "function") {
            node.opacity(1);
          }

          if (typeof node.visible === "function") {
            node.visible(true);
          }

          if (typeof node.globalCompositeOperation === "function") {
            node.globalCompositeOperation("source-over");
          }

          if (typeof node.filters === "function") {
            node.filters([]);
          }

          if (typeof node.clearCache === "function") {
            node.clearCache();
          }

          hideLogoAreaWhitePath(node);

          const ancestors =
            typeof node.getAncestors === "function" ? node.getAncestors() : [];

          ancestors.forEach((ancestor) => {
            if (
              ancestor &&
              typeof ancestor.opacity === "function" &&
              ancestor.getClassName?.() === "Group"
            ) {
              ancestor.opacity(1);
            }
          });

          hideWhiteLogoBackgroundNodes(node);

          if (typeof node.moveToTop === "function") {
            node.moveToTop();
          }

          node.getLayer?.()?.batchDraw?.();
          stage.batchDraw?.();

          changed += 1;
        }
      }

      log(`Tinted ${changed} logo node(s) with ${color}`);
    } catch (error) {
      console.warn("[CPB Logo Tint Fix] Failed:", error);
    } finally {
      runtime.running = false;
    }
  }

  function scheduleTint() {
    tintLogoNodes();

    queueMicrotask(() => {
      tintLogoNodes();
    });

    requestAnimationFrame(() => {
      tintLogoNodes();

      requestAnimationFrame(() => {
        tintLogoNodes();
      });
    });

    setTimeout(tintLogoNodes, 25);
    setTimeout(tintLogoNodes, 75);
    setTimeout(tintLogoNodes, 150);
    setTimeout(tintLogoNodes, 300);
  }

  function debug() {
    console.log("[CPB Logo Tint Fix] color:", getTargetColor());

    getStages().forEach((stage, stageIndex) => {
      const imageNodes = stage.find("Image") || [];

      console.log(
        `[CPB Logo Tint Fix] stage ${stageIndex}, images:`,
        imageNodes.length
      );

      imageNodes.forEach((node, nodeIndex) => {
        const image = node.image?.();
        const src = getImageSrc(image);

        console.log({
          nodeIndex,
          width: node.width?.(),
          height: node.height?.(),
          x: node.x?.(),
          y: node.y?.(),
          visible: node.isVisible?.(),
          isCandidate: isLogoCandidate(node),
          isCanvas: isCanvas(image),
          hasSrc: Boolean(src),
          srcStart: src ? src.slice(0, 70) : "",
          node,
        });
      });
    });
  }

  function destroy() {
    if (runtime.observer) {
      runtime.observer.disconnect();
      runtime.observer = null;
    }

    if (runtime.unsubscribe) {
      runtime.unsubscribe();
      runtime.unsubscribe = null;
    }

    document.removeEventListener("pointerdown", scheduleTint, true);
    document.removeEventListener("click", scheduleTint, true);
    document.removeEventListener("change", scheduleTint, true);
    document.removeEventListener("input", scheduleTint, true);

    runtime.initialized = false;
  }

  function init() {
    if (runtime.initialized) return;

    runtime.initialized = true;

    document.addEventListener("pointerdown", scheduleTint, true);
    document.addEventListener("click", scheduleTint, true);
    document.addEventListener("change", scheduleTint, true);
    document.addEventListener("input", scheduleTint, true);

    const store = window.CPB?.getStore?.();

    if (store?.subscribe) {
      runtime.unsubscribe = store.subscribe(scheduleTint);
    }

    runtime.observer = new MutationObserver(scheduleTint);
    runtime.observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    window.__CPBLogoTintFix = {
      run: tintLogoNodes,
      schedule: scheduleTint,
      debug,
      destroy,
    };

    scheduleTint();
  }

  function waitForCpb() {
    if (window.CPB?.getStore?.() && window.Konva?.stages?.length) {
      init();
      return;
    }

    setTimeout(waitForCpb, 250);
  }

  waitForCpb();
})();
